/*
 * @Author: your name
 * @Date: 2020-11-03 16:11:56
 * @LastEditTime: 2021-08-10 15:56:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\api\api.js
 */
import http from './../utils/http'
const RESQUEST_API = "/api"         //获取数据


//登录
export const getLoginApi = params => http.axios('post', `${RESQUEST_API}/v1/login`, params)

// 第三方跳转登录
export const getThirtyLoginApi = params => http.axios('post', `${RESQUEST_API}/v1/third/jumpToVerify`, params)

//获取短信验证码
export const getSmsSendApi = params => http.axios('get', `${RESQUEST_API}/v1/smsSend`, params)

//忘记密码-手机验证
export const getPwdCheckMobileApi = params => http.axios('post', `${RESQUEST_API}/v1/pwdCheckMobile`, params)

//忘记密码-修改密码
export const getSetNewPwdApi = params => http.axios('post', `${RESQUEST_API}/v1/setNewPwd`, params)

//绑定手机号
export const getBindMobileApi = params => http.axios('post', `${RESQUEST_API}/v1/user/bindMobile`, params)

//注册
export const getRegisterApi = params => http.axios('post', `${RESQUEST_API}/v1/register`, params)

//首页
export const getHomeApi = params => http.axios('get', `${RESQUEST_API}/v1/getHomeInfo`, params)

//证书查询
export const getCertSearchApi = params => http.axios('post', `${RESQUEST_API}/v1/search/cert`, params)

//证书查询--验证码（登录）
export const getCaptchaApi = params => http.axios('get', `${RESQUEST_API}/v1/captcha`, params)

//证书-机构
export const getSearchOrgApi = params => http.axios('get', `${RESQUEST_API}/v1/search/org`, params)

//证书-渠道
export const getSearchChannelApi = params => http.axios('get', `${RESQUEST_API}/v1/search/channel`, params)

//关于我们-列表
export const getAboutUsApi = params => http.axios('get', `${RESQUEST_API}/v1/about/index`, params)

//关于我们-详情
export const getAboutDetApi = params => http.axios('get', `${RESQUEST_API}/v1/about/detail`, params)

//联系我们
export const getTelUsApi = params => http.axios('post', `${RESQUEST_API}/v1/telUs`, params)

//留言板
export const getMessageApi = params => http.axios('post', `${RESQUEST_API}/v1/getMessage`, params)

//个人中心-个人信息
export const getUserInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/user/userinfo`, params)

//个人中心-认证岗位
export const getAttestListApi = params => http.axios('get', `${RESQUEST_API}/v1/user/attestlist`, params)

//个人中心-实操
export const getOpInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/getOpInfo`, params)

//获取实操试题
export const getOpExamApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/operationExam`, params)

//提交实操试题
export const gethandAnswerApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/handAnswer`, params)

//交卷-实操
export const gethandOperationApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/handOperation`, params)

//个人中心-就业岗位
export const getJobListApi = params => http.axios('get', `${RESQUEST_API}/v1/user/joblist`, params)

//个人中心-证书列表
export const getCertApi = params => http.axios('get', `${RESQUEST_API}/v1/user/getCertList`, params)

//个人中心-我的订单
export const getOrderApi = params => http.axios('get', `${RESQUEST_API}/v1/user/myOrder`, params)

//个人中心-课程列表
export const getCourseListApi = params => http.axios('get', `${RESQUEST_API}/v1/user/mycourse`, params)

//个人中心-修改密码
export const getChangePwdApi = params => http.axios('post', `${RESQUEST_API}/v1/user/changePwd`, params)

//实训-列表
export const getPracticalListApi = params => http.axios('get', `${RESQUEST_API}/v1/train/getList`, params)

//实训-详情
export const getPracticalDetApi = params => http.axios('get', `${RESQUEST_API}/v1/train/getdetail`, params)

//线上实训详情
export const getCloudDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/train/getCloudDetail`, params)

//线上实训详情-获取第三方token
export const getAuthInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/paixy/getAuthInfo`, params)

//实训-线下课程表  
export const getClassListApi = params => http.axios('get', `${RESQUEST_API}/v1/train/getClass`, params)

//考试-考试信息确认
export const getExamInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/getInfo`, params)

//考试-补考
export const getReexamineApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/reexamine`, params)

//考试-人脸识别
export const getFaceAuthApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/faceAuth`, params)

//考试-生成试卷
export const getInitApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/init`, params)

//考试-获取试卷信息
export const getPaperInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/getPaperInfo`, params)

//考试-保存答案
export const getPutAnswerApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/putAnswer`, params)

//考试-获取指定试题
export const getQuestionApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/getQuestion`, params)

//考试-提交试卷
export const getPaperApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/handPaper`, params)

//考试-查看试卷
export const getSeePaperApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/seePaper`, params)

//考试-查看试卷获取指定题目
export const getOnePaperApi = params => http.axios('get', `${RESQUEST_API}/v1/exam/getOnePaperQuestion`, params)

//考试-模拟答题
export const getMockInfoApi = params => http.axios('get', `${RESQUEST_API}/v1/examMock/getPaperInfo`, params)

//考试-模拟指定试题
export const getMockQuestionApi = params => http.axios('get', `${RESQUEST_API}/v1/examMock/getQuestion`, params)

//学习课程
export const getcourseIndexApi = params => http.axios('get', `${RESQUEST_API}/v1/course/index`, params)

// 学习课程列表
export const getcourseListNewApi =  params => http.axios('get', `${RESQUEST_API}/V1/course/courselist`, params)

//学习课程详情
export const getcourseDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/course/detail`, params)

//学习课程-支付
export const getPayMentApi = params => http.axios('post', `${RESQUEST_API}/v1/pay/paymentRequest`, params)

//学习课程-支付-完成
export const getPayOverApi = params => http.axios('post', `${RESQUEST_API}/v1/pay/isPayOver`, params)

//岗位认证
export const getattestIndexApi = params => http.axios('get', `${RESQUEST_API}/v1/attest/getCertList`, params)

//岗位认证-分类
export const getCateApi = params => http.axios('get', `${RESQUEST_API}/v1/attest/getCertCateList`, params)

//岗位认证分类
export const getcateListApi = params => http.axios('get', `${RESQUEST_API}/v1/course/cateList`, params)


//岗位认证详情
export const getattestDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/attest/detail`, params)

//岗位认证课程
export const getattestLooklistApi = params => http.axios('get', `${RESQUEST_API}/v1/attest/looklist`, params)

//培训岗位-报名
export const getcourseApplyApi = params => http.axios('post', `${RESQUEST_API}/v1/attest/apply`, params)

//培训岗位-报名
export const getareaApi = params => http.axios('get', `${RESQUEST_API}/v1/attest/area`, params)

//常见问题
export const getProblemApi = params => http.axios('get', `${RESQUEST_API}/v1/problem/index`, params)

//获取测验题目
export const getTestPaperApi = params => http.axios('get', `${RESQUEST_API}/v1/examLesson/getPaperInfo`, params)

//获取保存答案
export const saveAnswerApi = params => http.axios('post', `${RESQUEST_API}/v1/examLesson/saveAnswer`, params)




//图片上传
export const UploadImgApi = params => http.axios('post',`${RESQUEST_API}/upload/base64`,params)

//考试监控-图片上传
export const UploadmonitorApi = params => http.axios('post',`${RESQUEST_API}/upload/monitor`,params)
// -----------------------------------------
// 实操文件上传
export const handScratchApi = params => http.axios('post', `${RESQUEST_API}/v1/exam/handScratchAnswer`, params )



//获取资讯标签
export const getNewsNavApi = params => http.axios('get', `${RESQUEST_API}/v1/news/getNav`, params)

//获取资讯列表
export const getnewsApi = params => http.axios('get', `${RESQUEST_API}/v1/news/getList`, params)

//获取资讯详情
export const getNewsDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/news/getDetail`, params)


// //培训岗位
// export const getcerListApi = params => http.axios('get', `${RESQUEST_API}/v1/cert/getList`, params)

// //培训岗位详情
export const getcerDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/cert/getDetail`, params)

//培训岗位课程学习
export const getcourseListApi = params => http.axios('get', `${RESQUEST_API}/v1/course/getList`, params)

//培训岗位-证书列表
export const getSonCertApi = params => http.axios('get', `${RESQUEST_API}/v1/cert/getSonCert`, params)

// //培训岗位-单个证书列表
export const getCertNameApi = params => http.axios('get', `${RESQUEST_API}/v1/cert/getCertName`, params)

//课程学习视频
export const getcourseLessonApi = params => http.axios('get', `${RESQUEST_API}/v1/course/getLessonDetail`, params)

//视频总时长
export const getSaveVideoLenApi = params => http.axios('post', `${RESQUEST_API}/v1/course/saveVideoLen`, params)

//记录播放时长
export const getRecordLookTimeApi = params => http.axios('post', `${RESQUEST_API}/v1/course/recordLookTime`, params)

//视频播放讨论-列表
export const getCourseCommentApi = params => http.axios('get', `${RESQUEST_API}/v1/comment/getCourseComment`, params)

//视频播放讨论-列表详情
export const getcommentDetailApi = params => http.axios('get', `${RESQUEST_API}/v1/comment/getcommentDetail`, params)

//视频播放讨论-回复
export const getSaveCommentApi = params => http.axios('post', `${RESQUEST_API}/v1/comment/saveComment`, params)

//视频播放讨论-推荐标签
export const getTagRecomApi = params => http.axios('get', `${RESQUEST_API}/v1/comment/getTagRecom`, params)

//视频播放讨论-已采纳
export const getIsAdoptApi = params => http.axios('post', `${RESQUEST_API}/v1/comment/isAdopt`, params)

//个人中心-信息提交
export const getRealNameApi = params => http.axios('post', `${RESQUEST_API}/v1/user/realName`, params)

//个人中心-我的提问
export const getMyCommentApi = params => http.axios('get', `${RESQUEST_API}/v1/user/getMyComment`, params)

// 首页提示信息弹框记录
export const noticeModalApi = params => http.axios('post', `${RESQUEST_API}/v1/alreadyTip`, params)
// 登录
export const loginAuthor = params => http.axios('get', `${RESQUEST_API}/v1/casd/login`, params)
// 登录回调
export const loginCallback = params => http.axios('get', `${RESQUEST_API}/v1/casd/callback`, params)
// 记录切屏
export const changeScreenCut = params => http.axios('get', `${RESQUEST_API}/v1/exam/recordScreenCut`, params)

// 签权回调处理
export const authCallback = params => http.axios('get', `${RESQUEST_API}/v1/hgciAccess/hgciDoLogin`, params)

// 签权回调页面获取证书信息
export const certInfoAPi = params => http.axios('get', `${RESQUEST_API}/v1/user/attestOneCert`, params)

export const errorQuestion = params => http.axios('get', `${RESQUEST_API}/v1/examMock/getErrorQuestionRow`, params)
// 
export const saveMockError = params => http.axios('post', `${RESQUEST_API}/v1/examMock/getQuestionAnswer`, params)
// 
export const deleteError = params => http.axios('post', `${RESQUEST_API}/v1/examMock/removeErrorQuestion`, params)
// 
export const practicalTrain = params => http.axios('post', `${RESQUEST_API}/v1/HgciOpExam/addExam`, params)
// 对接实训平台课程进度
// 课程章节目录
export const courseChapterApi = params => http.axios('get', `${RESQUEST_API}/v1/hgciCourse/getCourseLesson`, params)
// 课程资源
export const courseResourceApi = params => http.axios('get', `${RESQUEST_API}/v1/HgciCourse/getChapterVideo`, params)
// 视频学习上报
export const courseReport = params => http.axios('get', `${RESQUEST_API}/v1/HgciCourse/learnedReport`, params)
// 章节课件
export const courseFileApi = params => http.axios('get', `${RESQUEST_API}/v1/HgciCourse/getChapterWare`, params)
// 获取实训地址
export const trainUrlApi = params => http.axios('get', `${RESQUEST_API}/v1/HgciCourse/getChapterTrain`, params)
// 替换第三方的实训环境
export const trainAi = params => http.axios('get', `${RESQUEST_API}/v1/HgciCourse/getCourseUrl`, params)
// 获取视频课件
export const videoCourseApi = params => http.axios('get',`${RESQUEST_API}/v1/HgciCourse/getChapterRow`, params)


// WEBPACK FOOTER //
// ./src/api/api.js